import React from 'react';
import { motion } from 'framer-motion';
import { Flame } from 'lucide-react';
import { DjayGrowthState } from '../../shared/DjayGrowthState';
import { GrowthStage } from '../../../mastery';
import { RADIUS } from '../../../config/designTokens';
interface JourneyTrailheadProps {
  overallGrowthStage: GrowthStage;
  overallMastery: number;
  currentStreak: number;
}
export function JourneyTrailhead({
  overallGrowthStage,
  overallMastery,
  currentStreak
}: JourneyTrailheadProps) {
  return <div className="flex flex-col items-center text-center pt-8 pb-12 relative z-10" data-id="element-1916" data-mp="p5bk3j12x60g">
      <motion.div initial={{
      scale: 0.8,
      opacity: 0,
      y: 20
    }} animate={{
      scale: 1,
      opacity: 1,
      y: 0
    }} transition={{
      type: 'spring',
      bounce: 0.5
    }} className="relative mb-6" data-id="element-1917" data-mp="kf4vhj6khli7">
        <div className="absolute inset-0 bg-amber-200 blur-3xl opacity-30 rounded-full" data-id="element-1918" data-mp="184fqsl55enoy" />

        <div className={`bg-white border-4 border-amber-100 p-4 ${RADIUS.card} shadow-xl relative z-10 flex flex-col items-center gap-3`} data-id="element-1919" data-mp="28wizpk3ryent">
          <div className="flex items-center gap-3" data-id="element-1920" data-mp="2d0qotie59wmk">
            <div className="w-16 h-16 rounded-full bg-amber-50 flex items-center justify-center border-2 border-amber-200 shadow-inner" data-id="element-1921" data-mp="1z8121bqsknoe">
              <DjayGrowthState masteryScore={overallMastery} size="lg" data-id="element-1922" data-mp="244hswdpdlg56" />
            </div>
            <div className="text-left" data-id="element-1923" data-mp="1p7idi3oa8j05">
              <p className="text-sm font-bold text-slate-400 uppercase tracking-wider" data-id="element-1924" data-mp="1u84ux3mssg4m">
                Jouw groei
              </p>
              <h1 className="text-2xl sm:text-3xl font-black text-slate-800" data-id="element-1925" data-mp="1g9f2i1axb4ml">
                {overallGrowthStage.label}
              </h1>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Campfire Streak */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.3
    }} className="flex flex-col items-center gap-2" data-id="element-1926" data-mp="3an6akwdltgfx">
        <div className="relative w-16 h-16 flex items-center justify-center" data-id="element-1927" data-mp="395he01s42xjr">
          <motion.div animate={{
          scale: [1, 1.1, 0.95, 1.05, 1],
          rotate: [-2, 3, -1, 2, 0]
        }} transition={{
          repeat: Infinity,
          duration: 2,
          ease: 'easeInOut'
        }} className="absolute inset-0 bg-orange-500/20 blur-xl rounded-full" data-id="element-1928" data-mp="397llsut4sgpb" />
          <Flame className="w-10 h-10 text-orange-500 relative z-10 drop-shadow-md" fill="currentColor" data-id="element-1929" data-mp="3rwijz9rnftct" />
        </div>
        <div className="bg-orange-100 text-orange-800 px-4 py-1.5 rounded-full text-sm font-black shadow-sm border border-orange-200" data-id="element-1930" data-mp="3i6fismadj93e">
          {currentStreak} dagen op rij
        </div>
      </motion.div>
    </div>;
}